import { Component } from 'base/js/aem';
import { richTextYtLinks } from 'base/js/templates/general/youtubeModal.js';

class Teaser extends Component {
    init() {
        // Add Aria-label to YouTube Image Modal Link
        this.teaserImage = this.element.querySelector('.horzimage');
        this.imageLink = this.element.querySelector('.cmp-image__link');
        this.imageTitleLink = this.element.querySelector('.card-image-link');
        this.hasVideo = this.element.querySelector('.yt-play-button');
        this.actions = this.element.querySelectorAll('.card-link');
        this.titleLink = this.element.querySelector('.card-heading-link');
        this.cardText = this.element.querySelector('.card-text');
        if (this.imageLink && (this.imageLink.dataset.modalType === 'youtube' || this.imageLink.dataset.modalType === 'native')) {
            const modalText = this.teaserImage.dataset.videoModalText ?? '';
            const sanitizedModalText = modalText.replace(/\u200B/g, '');
            const openModalText = this.teaserImage.dataset.openModalText;
            this.imageLink.ariaLabel = `${sanitizedModalText} ${openModalText}`;
        }
        this.links = this.element.querySelectorAll('.card-text a');
        richTextYtLinks(this.links);
        if (this.links.length === 0) {
            this.initializeClick();
        }
        this.initializeAccessibility();
    }

    initializeAccessibility() {
        if (this.actions) {
            const links = new Set();
            this.actions.forEach(action => links.add(action.href));
            if (this.titleLink && links.has(this.titleLink.href)) {
                this.titleLink.tabIndex = -1;
            } else if (this.titleLink) {
                links.add(this.titleLink.href);
            }
            if (this.imageTitleLink && links.has(this.imageTitleLink.href)) {
                this.imageTitleLink.tabIndex = -1;
            }
        }
    }

    initializeClick() {
        function openAction(e) {
            const target = e.currentTarget;
            if (e.target.closest('a')) {
                return;
            }
            let link;
            if (target.querySelector('.card-link')) {
                link = target.querySelector('.card-link');
            } else if (target.querySelector('.card-heading-link')) {
                link = target.querySelector('.card-heading-link');
            }

            if (link && link.href) {
                if ('dataLayer' in window) {
                    window.dataLayer.push({
                        event: 'teaserClick',
                        teaserCTA: link.innerText,
                        teaserDestURL: link.href
                    });
                }
                if (link.target === '_blank' || e.ctrlKey || e.metaKey) {
                    window.open(link.href);
                } else {
                    window.location.href = link.href;
                }
            }
        }

        if (this.actions.length === 1 && !this.hasVideo && this.cardText) {
            this.element.classList.add('cursor-pointer');
            this.element.addEventListener('click', openAction, true);
        } else if (this.titleLink && this.actions.length === 0 && !this.hasVideo) {
            this.element.addEventListener('click', openAction, true);
            this.element.classList.add('cursor-pointer');
        }
    }
}

export { Teaser };
